export const SPLASH_ENTRANCE_DURATION_MS = 1000;
